import { ICollaboration } from '@descomplica/microfrontend-core';
import { inject, injectable } from 'tsyringe';

import type {
  UserMicrocertificate,
  UserMicrocertificateGateway,
} from '../../interfaces/user-microcertificate.interface';

@injectable()
export class GetUserMicrocertificateCollaboration
  implements ICollaboration<string, UserMicrocertificate | null>
{
  constructor(
    @inject('UserMicrocertificateGateway')
    private readonly userMicrocertificateGateway: UserMicrocertificateGateway,
  ) {}

  async run(hash: string): Promise<UserMicrocertificate | null> {
    return this.userMicrocertificateGateway.getMicrocertificate(hash);
  }
}
